var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRadioButtonLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "fi-icon-radio-base",
    cx: 15,
    cy: 15,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fi-icon-radio-checked",
    cx: 15,
    cy: 15,
    r: 8
  }))));
}

export default SvgIconRadioButtonLarge;